import * as ActionTypes from "../actions/actionTypes";

const initialState = {
  loading: true,
  messages: [],
  messageAlert: false,
};

export const messageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.MESSAGES_LOADED:
      state = {
        ...state,
        messages: action.payload.messages,
        loading: false,
      };
      break;
    case ActionTypes.MESSAGES_LOADING:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ActionTypes.MESSAGES_DELETED_ALERT:
      state.messageAlert = true;
      break;
    case ActionTypes.MESSAGES_CLEAR_ALERT:
      state.messageAlert = false;
      break;
    default:
      break;
  }
  return state;
};






// WEBPACK FOOTER //
// ./src/reducers/messageReducer.js